var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeeDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      width: 48,
      height: 48,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\r\n\t.st0{fill:#4B4B4B;}\r\n\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.391,0C71,0,11.516,28.969,11.516,64.719v34.563C11.516,135.031,71,164,144.391,164 c73.359,0,132.859-28.969,132.859-64.719V64.719C277.25,28.969,217.75,0,144.391,0z M144.391,26.875 c64.688,0,105.969,24.844,105.969,37.844s-41.281,37.844-105.969,37.844c-64.719,0-105.984-24.844-105.984-37.844 S79.672,26.875,144.391,26.875z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.375,216c24.578,0,47.594-3.281,67.344-8.938c-19.016,16.719-34.578,37.375-45.547,60.563 c-7.063,0.578-14.344,0.906-21.797,0.906c-73.359,0-132.859-29.016-132.859-64.75v-40.625c0-0.656,0.5-1.25,1.156-1.313 c0.313-0.094,0.656,0.063,0.891,0.406c-0.156,0,0,0.469,0.906,2.688C27.328,194.125,80.594,216,144.375,216z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.047,348.094c0,7.969,0.5,15.75,1.547,23.438c-1.703,0.094-3.438,0.094-5.219,0.094 c-73.359,0-132.859-28.938-132.859-64.656v-40.734c0-0.578,0.5-1.141,1.156-1.234c0.531-0.063,0.875,0.25,1.125,0.625 c-0.313-0.406-0.641-0.625,0.672,2.5c12.859,29.156,66.125,51.063,129.906,51.063c1.969,0,4.016,0,5.969-0.188 C148.781,328.516,148.047,338.188,148.047,348.094z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.203,470.281c-15.078,2.969-31.547,4.516-48.828,4.516c-73.359,0-132.859-28.922-132.859-64.734v-40.656 c0-0.656,0.5-1.156,1.156-1.219c0.5-0.094,0.969,0.156,1.141,0.656c-0.328-0.406-0.734-0.813,0.656,2.375 c12.859,29.25,66.125,51.125,129.906,51.125c6.297,0,12.609-0.25,18.672-0.656C170.578,439.469,180.828,455.875,193.203,470.281z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "387.891,337.516 352.516,337.516 348.734,343.406 348.734,357.563 387.891,357.563 387.891,357.625  387.891,374.781 387.891,377.656 348.734,377.656 348.734,408 324.406,408 324.406,377.656 285.25,377.656 285.25,374.781  285.25,357.625 285.25,357.563 324.406,357.563 324.406,343.438 320.609,337.516 285.25,337.516 285.25,320.344 309.563,320.344  288.891,288.188 309.5,288.188 336.563,330.281 363.625,288.188 384.25,288.188 363.578,320.344 387.891,320.344  ",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.563,225.156c67.781,0,122.938,55.156,122.938,122.938s-55.156,122.938-122.938,122.938 c-67.766,0-122.922-55.156-122.922-122.938S268.797,225.156,336.563,225.156 M336.563,184.188 c-90.531,0-163.891,73.391-163.891,163.906c0,90.531,73.359,163.906,163.891,163.906s163.922-73.375,163.922-163.906 C500.484,257.578,427.094,184.188,336.563,184.188z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeDetails);
export default __webpack_public_path__ + "static/media/FeeDetails.ec1cda829cc28246183e74a05bc8fd2b.svg";
export { ForwardRef as ReactComponent };